import React from 'react';
import { Container } from 'reactstrap';
import UiContent from '../../../../Components/Common/UiContent';
import BreadCrumb from '../../../../Components/Common/BreadCrumb';
import PagesList from './PagesList';

//redux

const Pages = () => {
	const breadcrumbLinks = [
		{ to: '#', label: 'Inicio' },
	];

	return (
		<React.Fragment>
			<UiContent />
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb title='Páginas' links={breadcrumbLinks} />
					<PagesList />
				</Container>
			</div>
		</React.Fragment>
	);
};

export default Pages;
